import Component from '../core/Component'

export default class Page extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const target = event.target.closest('[data-gtm-event]')

        if (!target) {
            return
        }

        try {
            const data = JSON.parse(target.dataset.gtmEvent)

            if (window.dataLayer) {
                window.dataLayer.push(data)
            }

        } catch (e) {

        }
    }
}